import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "button",
    "submitButton",
    "paymentGatewayType",
    "subscriptionPlanPriceId",
    "errorContainer",
    "errorMsg",
  ]

  connect() {
    this.setPaymentButtonState();
    this.attachEventToModal()
  }

  setPaymentButtonState() {
    let buttonActivated = false;

    for (var button of this.buttonTargets) {
      const container = button.closest(".js-button-container");

      // set enable/disable
      if (button.dataset.enable === "true") {
        container.classList.remove("tw-opacity-40");
        container.classList.add("tw-cursor-pointer");

      } else {
        container.classList.add("tw-opacity-40");
        container.classList.remove("tw-cursor-pointer");
      }

      // Deactivate by default
      button.classList.add("tw-border-transparent");
      button.classList.remove("tw-border-primary-500");

      // Activate and set default value
      if (!buttonActivated && container.classList.contains("tw-cursor-pointer")) {
        buttonActivated = true
        button.classList.add("tw-border-primary-500");
        button.classList.remove("tw-border-transparent");

        this.setFormFields(container);
      }
    }
  }

  attachEventToModal() {
    $(this.element).on('hidden.bs.modal', () => {
      this.errorContainerTarget.classList.add("tw-hidden");
      this.errorMsgTarget.innerHTML = '';
    })
  }

  select(e) {
    const container = e.currentTarget;
    const currentButton =
      container.querySelector(".js-subscription-plan-price-button");

    if (currentButton.dataset.enable === "false") {
      return e.preventDefault();
    }

    this.setFormFields(container);

    for (var button of this.buttonTargets) {
      this.toggleButton(button, false)
    }

    this.toggleButton(currentButton, true);
  }

  toggleButton(button, active) {
    if (active) {
      button.classList.remove("tw-border-transparent")
      button.classList.add("tw-border-primary-500");

      return;
    }

    button.classList.remove("tw-border-primary-500");
    button.classList.add("tw-border-transparent")
  }

  setFormFields(container) {
    this.subscriptionPlanPriceIdTarget.value = container.dataset.subscriptionPlanPriceId
    this.paymentGatewayTypeTarget.value = container.dataset.paymentGatewayType;
  }

  onPostSuccess(event) {
    const [data] = event.detail;

    if (data.type === "card" && data.hasOwnProperty("stripe_session_id")) {
      const stripe = Stripe(this.data.get("stripe-publishable-key"));

      stripe.redirectToCheckout({ sessionId: data.stripe_session_id });
    } else {
      window.location.href = data.redirect_url
    }
  }

  onPostError(event) {
    const [data] = event.detail;

    this.errorContainerTarget.classList.remove("tw-hidden");
    this.errorMsgTarget.innerHTML = data.error;
    this.submitButtonTarget.disabled = false;
    this.submitButtonTarget.classList.add("hover:tw-bg-primary-700", "tw-bg-primary-600");
  }

  onBefore() {
    this.errorContainerTarget.classList.add("tw-hidden");
    this.errorMsgTarget.innerHTML = "";
    this.submitButtonTarget.disabled = true;
    this.submitButtonTarget.classList.remove("tw-bg-primary-600", "hover:tw-bg-primary-700");
  }
}
